import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/Actions/userActions";
import FailAlert from "./../../../Components/Interactive/FailAlert";

// Component Imports
import InfluencerForm from "./InfluencerWidget/InfluencerForm";

const Influencer = ({ isOpen }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const createInfluencerAccount = async (
    email,
    firstName,
    lastName,
    vanityUrl,
    brandId
  ) => {
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Email: email,
        Firstname: firstName,
        Lastname: lastName,
        vanityUrl: vanityUrl,
        brandId: brandId
      }),
    };
  
    const res = await fetch("/api/influencer/signup", options);

    if (res.status === 401) {
      dispatch(logout());
      return navigate("/");
    }
    const { result, message, error } = await res.json();

    if(!error) {
      console.log(result);
      navigate(`/Customer/${result.customerId}`)
    }else {
      setErrorMessage(message);
    }
  };

  const onHandleSubmit = (email, firstName, lastName, vanityUrl, brandId) => {
    console.log(email, firstName, lastName, vanityUrl, brandId);
    if(!email || !firstName || !lastName || !vanityUrl || !brandId) {
      alert('All fields must be popualted to submit the request');
      return;
    }
    createInfluencerAccount(email, firstName, lastName, vanityUrl, brandId);
  };

  return (
    <div className={`${isOpen ? "page" : "page-closed"} container`}>
      {
        errorMessage ? (<FailAlert>{errorMessage}</FailAlert>) : null  
      }

      <h3 className="heading">Create Influencer Account</h3>
      <InfluencerForm
        onClick={onHandleSubmit}
      />
    </div>
  );
};

export default Influencer;
